import { BaseRouteRpc, RoleType } from '../../../../../core';
import { AuthProfileUpdateCompanyRequestSchema } from './request';
import { AuthProfileUpdateCompanyResponseSchema } from './response';
  
/**
* @description
*
*
* Request interface:
* ```
* export interface AuthProfileUpdateCompanyRequestSchema extends ContractData {
*     data: Data;
* }
*
* export interface Data {
*     name?:      string;
*     storeUrls?: string[];
*     url?:       string;
* }
*
* ```
* Response interface:
*
* ```
* export interface AuthProfileUpdateCompanyResponseSchema extends ContractData {
*     profile: Profile;
* }
*
* export interface Profile {
*     company?:  Company;
*     email:     string;
*     firstName: string;
*     id:        string;
*     lastName:  string;
*     phone:     string;
*     role:      number;
* }
*
* export interface Company {
*     name?:      string;
*     storeUrls?: string[];
*     url?:       string;
* }
*
* ```
*/
export class AuthProfileUpdateCompanyRouteRpc extends BaseRouteRpc {
  static method = 'auth-profile-update-company';

  static request: AuthProfileUpdateCompanyRequestSchema;
  static response: AuthProfileUpdateCompanyResponseSchema;

  static role = RoleType.unverified;
}
